"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.diseasesMessages = exports.Diseases = void 0;
const schema_1 = require("../../../../../schema");
var Diseases;
(function (Diseases) {
    Diseases["ISCHAEMIC_HEART_DISEASE"] = "ischaemic_heart_disease";
    Diseases["ACUTE_MYOCARDIAL_INFARCTION"] = "acute_myocardial_infarction";
    Diseases["HYPERTENSION"] = "hypertension";
    Diseases["CARDIAC_ARRHYTHMIA"] = "cardiac_arrhythmia";
    Diseases["CARDIOMYOPATHY"] = "cardiomyopathy";
    Diseases["PERICARDITIS"] = "pericarditis";
    Diseases["ENDOCARDITIS"] = "endocarditis";
    Diseases["TRANSIENT_ISCHEMIC_ATTACK"] = "transient_ischemic_attack";
    Diseases["VALVULAR_HEART_DISEASE"] = "valvular_heart_disease";
    Diseases["OTHER"] = "other";
})(Diseases || (exports.Diseases = Diseases = {}));
exports.diseasesMessages = {
    [Diseases.ISCHAEMIC_HEART_DISEASE]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.cardiovascularDiseases.diseases.ISCHAEMIC_HEART_DISEASE",
        defaultMessage: "Ischaemiás szívbetegség (ISZB)"
    },
    [Diseases.ACUTE_MYOCARDIAL_INFARCTION]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.cardiovascularDiseases.diseases.ACUTE_MYOCARDIAL_INFARCTION",
        defaultMessage: "Akut myocardialis infarctus (AMI)"
    },
    [Diseases.HYPERTENSION]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.cardiovascularDiseases.diseases.HYPERTENSION",
        defaultMessage: "Hypertonia"
    },
    [Diseases.CARDIAC_ARRHYTHMIA]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.cardiovascularDiseases.diseases.CARDIAC_ARRHYTHMIA",
        defaultMessage: "Ritmuszavar"
    },
    [Diseases.CARDIOMYOPATHY]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.cardiovascularDiseases.diseases.CARDIOMYOPATHY",
        defaultMessage: "Cardiomyopathia"
    },
    [Diseases.PERICARDITIS]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.cardiovascularDiseases.diseases.PERICARDITIS",
        defaultMessage: "Pericarditis"
    },
    [Diseases.ENDOCARDITIS]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.cardiovascularDiseases.diseases.ENDOCARDITIS",
        defaultMessage: "Endocarditis"
    },
    [Diseases.TRANSIENT_ISCHEMIC_ATTACK]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.cardiovascularDiseases.diseases.TRANSIENT_ISCHEMIC_ATTACK",
        defaultMessage: "TIA (átmeneti ischaemiás attak)"
    },
    [Diseases.VALVULAR_HEART_DISEASE]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.cardiovascularDiseases.diseases.VALVULAR_HEART_DISEASE",
        defaultMessage: "Billentyűbetegség (vitium cordis)"
    },
    [Diseases.OTHER]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.cardiovascularDiseases.diseases.OTHER",
        defaultMessage: "Egyéb"
    }
};
const diseases = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Diseases.ISCHAEMIC_HEART_DISEASE),
    schema_1.Schema.singleChoiceItem(Diseases.ACUTE_MYOCARDIAL_INFARCTION),
    schema_1.Schema.singleChoiceItem(Diseases.HYPERTENSION),
    schema_1.Schema.singleChoiceItem(Diseases.CARDIAC_ARRHYTHMIA),
    schema_1.Schema.singleChoiceItem(Diseases.CARDIOMYOPATHY),
    schema_1.Schema.singleChoiceItem(Diseases.PERICARDITIS),
    schema_1.Schema.singleChoiceItem(Diseases.ENDOCARDITIS),
    schema_1.Schema.singleChoiceItem(Diseases.TRANSIENT_ISCHEMIC_ATTACK),
    schema_1.Schema.singleChoiceItem(Diseases.VALVULAR_HEART_DISEASE),
    schema_1.Schema.singleChoiceItem(Diseases.OTHER)
]).interpretation({ vocab: "ltx", code: "cardiovascular_disease" });
const comment = schema_1.Schema.string()
    .optional()
    .maxLength(1000)
    .interpretation({ vocab: "ltx", code: "cardiovascular_disease_comment" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ diseases, comment })
    .interpretation({ vocab: "ltx", code: "cardiovascular_disease_form" });
